import { render, staticRenderFns } from "./cell-user-relations.vue?vue&type=template&id=21518b71&scoped=true"
import script from "./cell-user-relations.ts?vue&type=script&lang=ts&external"
export * from "./cell-user-relations.ts?vue&type=script&lang=ts&external"
import style0 from "./cell-user-relations.vue?vue&type=style&index=0&id=21518b71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21518b71",
  null
  
)

export default component.exports